import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { ObjectiveReport } from '../../../types';
import dayjs from 'dayjs';
import { statusesLabel } from '../../../helper';

export const exportToExcel = (
  objectiveReportData: ObjectiveReport[],
  employeeData: {
    name: string;
    designation: string;
    tier: string;
    mentor: string;
    objectiveCount: number;
    lastAccessed: string;
  }[],
  fileName: string
) => {
  const reportData = objectiveReportData?.map((item: ObjectiveReport) => ({
    'Mentee Name': item?.menteeName,
    'Mentor Name': item?.mentorName,
    'Objective Type': item?.objectiveType,
    Description: item.description,
    Status: statusesLabel[item.status],
    'Expected Outcome': item?.expectedOutcome,
    'Start Date': dayjs(item?.startDate).format('YYYY-MM-DD'),
    'End Date': dayjs(item?.endDate).format('YYYY-MM-DD'),
  }));

  const employeeReportData = employeeData.map((item) => ({
    Name: item.name,
    Designation: item.designation,
    Tier: item.tier,
    Mentor: item.mentor,
    'Objective Count': item.objectiveCount,
    'Last Accessed': item?.lastAccessed
      ? dayjs(item?.lastAccessed).format('YYYY-MM-DD HH:mm:ss')
      : '',
  }));

  const reportDataWorksheet = XLSX.utils.json_to_sheet(reportData);
  const employeeReportDataWorksheet =
    XLSX.utils.json_to_sheet(employeeReportData);

  XLSX.utils.sheet_add_json(reportDataWorksheet, reportData, {
    origin: 'A01',
    skipHeader: false,
  });

  XLSX.utils.sheet_add_json(employeeReportDataWorksheet, employeeReportData, {
    origin: 'A01',
    skipHeader: false,
  });

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    employeeReportDataWorksheet,
    'Employee Database'
  );

  XLSX.utils.book_append_sheet(
    workbook,
    reportDataWorksheet,
    'Objective set for employees'
  );
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, `${fileName}.xlsx`);
};
